/*
  <kg-countdown>: zaehlt bis zu einem Zeitpunkt herunter. Der Zeitpunkt steht als
  Text im Attribut data-end, zum Beispiel "2026-12-24 18:00". Ohne Zeitzone gilt die
  des Besuchers, mit Angabe wie "+02:00" die angegebene.

  Ist die Zeit um, verschwindet der Zaehler. Mit data-expired="hide" verschwindet
  ausserdem der ganze Eintrag, damit keine abgelaufene Aktion stehen bleibt.
*/

const SEKUNDE = 1000;
const MINUTE = 60 * SEKUNDE;
const STUNDE = 60 * MINUTE;
const TAG = 24 * STUNDE;

class KgCountdown extends HTMLElement {
  connectedCallback() {
    this.ziel = this.lesen(this.dataset.end);
    this.felder = {
      days: this.querySelector('[data-countdown-days]'),
      hours: this.querySelector('[data-countdown-hours]'),
      minutes: this.querySelector('[data-countdown-minutes]'),
      seconds: this.querySelector('[data-countdown-seconds]'),
    };
    if (!this.ziel) {
      this.hidden = true;
      return;
    }
    this.zeichnen();
    this.takt = window.setInterval(() => this.zeichnen(), SEKUNDE);
  }

  disconnectedCallback() {
    window.clearInterval(this.takt);
  }

  /* "2026-12-24 18:00" versteht Safari nicht, mit T dazwischen schon */
  lesen(text) {
    if (!text) return null;
    const zeit = Date.parse(text.trim().replace(' ', 'T'));
    return Number.isNaN(zeit) ? null : zeit;
  }

  zeichnen() {
    const rest = this.ziel - Date.now();
    if (rest <= 0) {
      window.clearInterval(this.takt);
      this.abgelaufen();
      return;
    }
    const werte = {
      days: Math.floor(rest / TAG),
      hours: Math.floor((rest % TAG) / STUNDE),
      minutes: Math.floor((rest % STUNDE) / MINUTE),
      seconds: Math.floor((rest % MINUTE) / SEKUNDE),
    };
    /* Tage nur zeigen, solange welche uebrig sind */
    this.felder.days?.closest('.countdown__part')?.toggleAttribute('hidden', werte.days === 0);
    for (const [name, wert] of Object.entries(werte)) {
      const feld = this.felder[name];
      if (feld) feld.textContent = String(wert).padStart(2, '0');
    }
  }

  abgelaufen() {
    this.hidden = true;
    /* Der Streifen unter dem Werbebanner traegt nur den Zaehler, leer waere er ein grauer Balken */
    const streifen = this.closest('.promo-banner__timer');
    if (streifen) streifen.hidden = true;
    if (this.dataset.expired !== 'hide') return;
    const eintrag = this.closest('.announcement-bar__item');
    if (eintrag) eintrag.remove();
  }
}

customElements.define('kg-countdown', KgCountdown);
